<template>
  <div class="w-full">
    <div class="flex justify-between">
      <Back />
        <a
        @click.prevent="nextStep"
        class="focus:outline-none cursor-pointer text-white text-sm py-1 px-2 rounded-md bg-red-500 hover:bg-red-600 hover:shadow-lg flex items-center"
      >
        Selanjutnya : {{whatsNext == '' ? 'Selesai' : 'Tambah ' + whatsNext}}
        <i class="fas fa-arrow-right ml-2"></i>
      </a>  

    </div>
    <div>
      <Step
        :classroom="classroom"
        :step="step"
      />
    </div>
    <div class="grid grid-cols-1">
      <div>
        <div class="flex justify-between my-3">
            <p class="self-center">Daftar Webinar</p>
            <a @click.prevent="addNewWebinar" type="button"
              class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 sm:ml-3 sm:w-auto sm:text-sm">
              Tambah Webinar
            </a>
        </div>
        <DataTable :value="webinars" class="shadow p-datatable-sm font-sans text-sm" responsiveLayout="scroll" v-model:selection="selectedWebinar"
                selectionMode="single" @rowSelect="onRowSelectWebinar">
            <template #empty>
                <div class="text-center font-semibold text-red-600">
                  Belum ada webinar
                </div>
            </template>
            <template #loading>
                Loading webinar data. Please wait.
            </template>
            <Column selectionMode="single" headerStyle="width: 3em"></Column>
            <Column field="type" header="Tipe" sortable >
              <template #body="{data}">
                <div v-if="data?.type == 'webinar'">
                  <span
                      v-if="data?.is_plus == false"
                      class="relative inline-block px-3 py-1 font-semibold text-yellow-700 leading-tight">
                      <span aria-hidden
                          class="absolute inset-0 bg-yellow-400 opacity-50 rounded"></span>
                      <span class="relative">Webinar</span>
                  </span>
                  <span
                    v-else
                    class="relative inline-block px-3 py-1 font-semibold text-green-800 leading-tight"
                  >
                    <span aria-hidden
                          class="absolute inset-0 bg-green-400 opacity-50 rounded"></span>
                    <span class="relative">Webinar Plus</span>
                  </span>
                </div>
                <span
                    v-else
                    class="relative inline-block px-3 py-1 font-semibold text-pink-700 leading-tight">
                    <span aria-hidden
                        class="absolute inset-0 bg-pink-400 opacity-50 rounded"></span>
                    <span class="relative">Rekaman Webinar</span>
                </span>
              </template>
            </Column>
            <Column field="name" header="Nama Webinar" sortable>
              <template #body="{data}">
                {{ data.type == 'webinar' ? data.name : data.name }}
              </template>
            </Column>
            <Column field="started_at" header="Tanggal Webinar Berlangsung" sortable>
              <template #body="{data}">
                <div v-if="data?.type == 'webinar'">
                  <p>{{ dateFormat(data.started_at) }}</p>
                  <p>{{' s/d ' + dateFormat(data.expired_at) }}</p>
                </div>
                <div v-else>
                  {{ dateFormat(data.live_at) }}
                </div>
              </template>
            </Column>
            <Column field="is_active" header="Tampil di Member">
              <template #body="{data}">
                <a v-if="data.is_active || data.type == 'record'" class="inline-block rounded-full text-white 
                  bg-green-500 hover:bg-green-600 duration-300 
                  text-xs font-bold 
                  mb-2 px-2 py-1 
                  opacity-90 hover:opacity-100">
                  Tampil
                </a>
                <a v-else class="inline-block rounded-full text-white 
                  bg-red-500 hover:bg-red-600 duration-300 
                  text-xs font-bold 
                  mb-2 px-2 py-1 
                  opacity-90 hover:opacity-100">
                  Tidak Tampil
                </a>
              </template>
            </Column>
            <Column field="can_request_plus" header="Pengajuan Webinar++">
              <template #body="{data}">
                <i 
                  class="far"
                  style="font-size:1.75em;"
                  :class="data.can_request_plus ? 'fa-check-circle text-green-700' : 'fa-times-circle text-red-700'"
                ></i>
              </template>
            </Column>
            <Column field="id" header="Aksi">
              <template #body="{data}">
                <div v-if="data?.type == 'webinar'">
                    <a @click.prevent="editWebinar(data)" type="button" class="w-full mt-1 cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm">
                      <i class="fas fa-edit"></i>
                    </a>
                    <a @click.prevent="showDeleteWebinar(data)" type="button" class="w-full mt-1 cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                      <i class="fas fa-trash-alt"></i>
                    </a>
                </div>
                <div v-else>
                  <a @click.prevent="editWebinar(data)" type="button" class="w-full mt-1 cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm">
                    <i class="fas fa-edit"></i>
                  </a>
                  <a @click.prevent="showDeleteWebinarRecord(data.id)" type="button" class="w-full mt-1 cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                    <i class="fas fa-trash-alt"></i>
                  </a>
                </div>
              </template>
            </Column>
        </DataTable>
      </div>
    </div>
    <!-- <div class="md:grid md:grid-cols-6 md:gap-2"> -->
    <div class="md:grid md:grid-cols md:gap-2" v-if="selectedWebinar?.type == 'webinar'">
        <div class="md:col-span-3">
            <div class="flex justify-between my-3">
                <p class="self-center">Daftar Pre/Post-test {{ selectedWebinar?.name }}</p>
                <button @click.prevent="addWebinarQuizModal" type="button"
                  class.="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  :disabled="disabledWebinarQuiz">
                  Tambah Pre/Post-test
                </button>
            </div>
            <DataTable :value="webinarQuizzes" responsiveLayout="scroll" v-model:selection="selectedWebinarQuiz"
                selectionMode="single" @rowSelect="onRowSelectWebinarQuiz" class="shadow p-datatable-sm font-sans text-sm">
                  <template #empty>
                    <div class="text-center font-semibold text-red-600">
                    Belum ada data webinar quiz
                    </div>
                </template>
                <template #loading>
                    Loading quiz data. Please wait.
                </template>
                <Column selectionMode="single" headerStyle="width: 3em"></Column>
                <Column field="name" header="Nama Webinar Quiz" sortable></Column>
                <Column field="quiz_type" header="Tipe Soal" sortable>
                  <template #body="{data}">
                    <span
                        v-if="data?.quiz_type == 1"
                        class="relative inline-block px-3 py-1 font-semibold text-blue-700 leading-tight">
                        <span aria-hidden
                            class="absolute inset-0 bg-blue-400 opacity-50 rounded"></span>
                        <span class="relative">Post Test</span>
                    </span>
                    <span
                        v-else
                        class="relative inline-block px-3 py-1 font-semibold text-red-700 leading-tight">
                        <span aria-hidden
                            class="absolute inset-0 bg-red-400 opacity-50 rounded"></span>
                        <span class="relative">Pre Test</span>
                    </span>
                    <!-- {{ data.quiz_type == 1 ? 'Post Test' : 'Pre Test' }} -->
                  </template>
                </Column>
                <Column field="started_at" header="Dimulai" sortable>
                  <template #body="{data}">
                    {{ dateFormat(data.started_at) }}
                  </template>
                </Column>
                <Column field="ended_at" header="Berakhir" sortable>
                  <template #body="{data}">
                    {{ dateFormat(data.ended_at) }}
                  </template>
                </Column>
                <Column field="display" header="Soal yang tampil"></Column>
                <Column field="is_randomized" header="Diacak" style="text-align:center !important;">
                  <template #body="{data}">
                    <i 
                      class="far"
                      style="font-size:1.75em;"
                      :class="data.is_randomized ? 'fa-check-circle text-green-700' : 'fa-times-circle text-red-700'"
                    ></i>
                  </template>
                </Column>

                <Column field="id" header="Aksi">
                    <template #body="{data}">
                        <a @click="editWebinarQuiz(data)" type="button"
                            class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm">
                            <i class="fas fa-edit"></i>
                        </a>
                        <a @click="showDeleteWebinarQuiz(data)" type="button"
                            class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </template>
                </Column>
            </DataTable>
        </div>
        <div class="md:col-span-3" v-if="selectedWebinarQuiz">
              <div class="flex justify-between my-3">
                <p class="self-center">Daftar Pertanyaan Pre/Post-test {{ selectedWebinarQuiz.name }}</p>
                <a @click.prevent="addWebinarQuizAnswerModal" type="button"
                class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 sm:ml-3 sm:w-auto sm:text-sm">
                Tambah Pertanyaan
                </a>
            </div>
            <DataTable 
              :value="webinarQuizItems" 
              :paginator="true" 
              :rows="10" 
              dataKey="id" 
              :rowHover="true"
              @rowReorder="onRowReorder"
              filterDisplay="menu" 
              v-model:filters="filters" 
              :loading="loadingWebinarQuiz"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              :rowsPerPageOptions="[10, 25, 50]"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              responsiveLayout="scroll"
              class="p-datatable-sm font-sans text-sm"
            > 

                <template #empty>
                    <div class="text-center font-semibold text-red-600">
                    Belum ada soal pertanyaan
                    </div>
                </template>
                <template #loading>
                    Loading webinar quiz data. Please wait.
                </template>
                <Column :rowReorder="true" headerStyle="width: 2rem" :reorderableColumn="false" class="cursor-move px-0" />
                <Column field="ordering" header="Urutan"></Column>
                <Column field="question" header="Soal"></Column>
                <Column field="choices" header="Pilihan Jawaban">
                    <template #body="{data}">
                        <ul v-for="(q, i) in listQuestion(data.choices)" :key="i">
                            <li :class="i === data.answer ? 'text-red-600 font-bold':''">• {{q}}</li>
                        </ul>
                    </template>
                </Column>
                <Column field="point" header="Poin"></Column>

                <Column field="id" header="Aksi">
                    <template #body="{data}">
                        <a @click.prevent="editQuestions(data.id)" type="button"
                            class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-yellow-500 hover:bg-yellow-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                            <i class="fas fa-edit"></i>
                        </a>
                        <a @click.prevent="showDeleteWebinarQuizAnswer(data.id)" type="button"
                            class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
     <!-- video youtube -->
    <div v-else-if="selectedWebinar?.type == 'record'" class="shadow p-3 mt-3">
      <p class="font-bold text-lg mb-2 text-gray-700">{{selectedWebinarRecord?.name}}</p>
      <div v-safe-html="selectedWebinarRecord?.link">
      </div>
    </div>
    <!-- modal webinar -->
    <transition name="pop">
    <div v-if="displayModalWebinar"
      class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
      <div class="w-3/4 md:w-1/3 m-auto">
        <div class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-85">
          <div
            class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
            <h3 class="text-xl font-semibold text-white">
              {{ webinarId > 0 ? 'Ubah Webinar' : webinarRecordId > 0 ? 'Ubah Rekaman Webinar' : (webinarType ? 'Tambah Webinar' : 'Tambah Rekaman Webinar' ) }}
            </h3>
            <button
              class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
              v-on:click="closeWebinar">
              <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
            </button>
          </div>
          <div class="px-6 py-3 overflow-y-auto overflow-x-auto">
            <div v-if="webinarId == 0 && webinarRecordId == 0 " class="w-full pb-3 text-center">
              <div class="bg-gray-200 text-sm text-gray-500 leading-none border-2 border-gray-200 rounded-full inline-flex">
                <button class="inline-flex items-center transition-colors duration-300 ease-in focus:outline-none px-4 py-2" :class="webinarType == true ? 'bg-white text-blue-600 rounded-full font-bold' : 'hover:text-gray-600 focus:text-gray-600 rounded-l-full'" @click="webinarType = true" id="grid">
                  <i class="fas fa-video mr-2"></i>
                  <span>Webinar</span>
                </button>
                <button class="inline-flex items-center transition-colors duration-300 ease-in focus:outline-none px-4 py-2" :class="webinarType == false ? 'bg-white text-pink-600 rounded-full font-bold' : 'hover:text-gray-600 focus:text-gray-600 rounded-r-full'" @click="webinarType = false" id="list">
                  <i class="fas fa-record-vinyl mr-2"></i>
                  <span>Rekaman Webinar</span>
                </button>
              </div>

            </div>
            <div v-if="webinarType">
              <div class="w-full pb-3">
                <label for="question" class="block text-sm font-medium text-gray-700">
                  Nama Webinar
                </label>
                <div class="mt-1">
                  <input type="text" placeholder="Nama Webinar"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    v-model="formWebinar.name" />
                </div>
              </div>
              <div class="w-full pb-3">
                <label for="question" class="block text-sm font-medium text-gray-700">
                  Thumbnail Webinar
                </label>
                <div v-if="formWebinar.thumbnail">
                  <img :src="formWebinar.thumbnail" class="m-auto" alt="">
                </div>
                <div class="mt-1">
                  <input type="file" id="webinarThumbnail" ref="webinarThumbnail" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" @change="uploadThumbnail($event)"
                     />
                </div>
              </div>
              <div class="w-full pb-3">
                <div class="flex justify-between items-center">
                  <label for="question" class="block text-sm font-medium text-gray-700">
                    Link Webinar
                  </label>
                  <div>
                    <label for="toggle"  class="text-xs text-gray-700 mr-2 cursor-pointer" :class="!useRoom ? 'font-bold':''" >Link</label>
                    <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                        <input type="checkbox" name="toggle" id="toggle" v-model="useRoom" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"/>
                        <label for="toggle" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
                    </div>
                    <label for="toggle" class="text-xs text-gray-700 ml-2 cursor-pointer" :class="useRoom ? 'font-bold':'' ">Room</label>
                  </div>
                </div>
                <div class="mt-1">
                  <textarea v-if="!useRoom" name="" id="" rows="2" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" v-model="formWebinar.link" placeholder="Link Webinar"></textarea>
                  <!-- <input v-if="!useRoom" type="text" placeholder="Nama Link Webinar"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    v-model="formWebinar.link" /> -->
                  <Dropdown
                    v-else
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm text-xs border-gray-300 rounded-md"
                    v-model="selectedRoom" :options="rooms" optionLabel="link"
                    placeholder="Pilih Room" :filter="true" :showClear="true" />
                </div>
              </div>

              <div class="w-full pb-3">
                <div class="mt-1">
                  <div class="col-span-6 sm:col-span-3 ">
                      <div class="grid grid-cols-2 gap-2">
                          <div class="w-full">
                              <p class="block text-sm font-medium text-gray-700">Dimulai</p>
                                <!-- <Calendar id="formWebinar_started_at" v-model="formWebinar.started_at" class="w-full" :showTime="true" dateFormat="yy-mm-dd" :showSeconds="true" /> -->
                              <v-date-picker v-model="formWebinar.started_at" mode="dateTime" is24hr :popover="{ placement: 'left' }">
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input
                                    class="p-2 border rounded focus:outline-none focus:ring-indigo-500  focus:border-indigo-500 w-full text-sm text-gray-700 border-gray-300"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                  />
                                </template>
                              </v-date-picker>

                          </div>
                          
                            <div class="w-full">
                              <p class="block text-sm font-medium text-gray-700">Berakhir</p>
                                <!-- <Calendar id="formWebinar_expired_at" v-model="formWebinar.expired_at" class="w-full" :showTime="true" dateFormat="yy-mm-dd" :showSeconds="true" /> -->
                              <v-date-picker v-model="formWebinar.expired_at" mode="dateTime" is24hr :popover="{ placement: 'right' }">
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input
                                    class="p-2 border rounded focus:outline-none focus:ring-indigo-500  focus:border-indigo-500 w-full text-sm text-gray-700 border-gray-300"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                  />
                                </template>
                              </v-date-picker>
                          </div>
                      </div>
                    </div>
                </div>
              </div>
              <div class="w-full pb-3">
                <div class="flex items-start">
                  <div class="flex items-center h-5">
                      <input v-model="formWebinar.is_active" id="isActive" name="isActive" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer">
                  </div>
                  <div class="ml-3 text-sm">
                      <label for="isActive" class="font-medium text-gray-700 cursor-pointer">Muncul di Member Area</label>
                      <p class="text-gray-500 text-xs">Centang untuk menandakan webinar ini tampil di member area</p>
                  </div>
                </div>
              </div>
              <div v-if="!isWebinarPlus" class="w-full pb-0">
                <div class="flex items-start">
                  <div class="flex items-center h-5">
                      <input v-model="formWebinar.can_request_plus" id="can_request_plus" name="can_request_plus" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer">
                  </div>
                  <div class="ml-3 text-sm">
                      <label for="can_request_plus" class="font-medium text-gray-700 cursor-pointer">Pengajuan Webinar++</label>
                      <p class="text-gray-500 text-xs">Centang untuk menandakan webinar ini bisa request/mengajukan webinar++</p>
                  </div>
                  </div>
              </div>
              <div v-if="!isWebinarPlus && formWebinar.can_request_plus" class="w-full p-2 border-solid border-2 border-green-700 bg-green-100 rounded-md mt-2">
                <p class="block text-md font-semibold text-green-700 mb-2">Tanggal Pengajuan Webinar Plus<span class="text-green-600">*</span></p>
                <div class="mt-1">
                  <div class="col-span-6 sm:col-span-3 ">
                      <div class="grid grid-cols-2 gap-2">
                          <div class="w-full">
                              <p class="block text-sm font-medium text-green-700">Pengajuan Dimulai</p>
                                <!-- <Calendar id="request_plus_started_at" v-model="formWebinar.request_plus_started_at" class="w-full" :showTime="true" dateFormat="yy-mm-dd" :showSeconds="true" /> -->
                            <v-date-picker v-model="formWebinar.request_plus_started_at" mode="dateTime" is24hr>
                              <template v-slot="{ inputValue, inputEvents }">
                                <input
                                  class="p-2 border rounded focus:outline-none focus:ring-indigo-500  focus:border-indigo-500 w-full text-sm text-gray-700 border-gray-300"
                                  :value="inputValue"
                                  v-on="inputEvents"
                                />
                              </template>
                            </v-date-picker>
                          </div>
                          
                          <div class="w-full">
                            <p class="block text-sm font-medium text-green-700">Pengajuan Berakhir</p>
                                <!-- <Calendar id="request_plus_expired_at" v-model="formWebinar.request_plus_expired_at" class="w-full" :showTime="true" dateFormat="yy-mm-dd" :showSeconds="true" /> -->
                            <v-date-picker v-model="formWebinar.request_plus_expired_at" mode="dateTime" is24hr>
                              <template v-slot="{ inputValue, inputEvents }">
                                <input
                                  class="p-2 border rounded focus:outline-none focus:ring-indigo-500  focus:border-indigo-500 w-full text-sm text-gray-700 border-gray-300"
                                  :value="inputValue"
                                  v-on="inputEvents"
                                />
                              </template>
                            </v-date-picker>
                          </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="w-full pb-3">
                <label for="question" class="block text-sm font-medium text-gray-700">
                  Nama Rekaman Webinar
                </label>
                <div class="mt-1">
                  <input type="text" placeholder="Nama Rekaman Webinar"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    v-model="formWebinarRecord.name" />
                </div>
              </div>
              <div class="w-full pb-3">
                <label for="question" class="block text-sm font-medium text-gray-700">
                  Link Video
                </label>
                <div class="mt-1">
                  <textarea
                    placeholder="Link Rekaman Webinar"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    v-model="formWebinarRecord.link"  
                  ></textarea>
                  <p class="text-xs text-gray-500">Contoh Link: </p>
                  <p class="text-xs text-gray-500">
                    {{ '<iframe src="https://www.youtube.com/embed/fwD96blnYZ8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="full-width" style="height: 350px;"></iframe>' }}                    
                  </p>
                </div>
              </div>
              <div class="w-full pb-3">
                <label for="live_at" class="block text-sm font-medium text-gray-700">
                  Tanggal Webinar Berlangsung
                </label>
                <div class="mt-1">
                  <!-- <Calendar id="endedAt" v-model="formWebinarRecord.live_at" class="w-full" :showTime="true" dateFormat="yy-mm-dd" :showSeconds="true" placeholder="Tanggal Webinar Berlangsung" /> -->
                  <v-date-picker v-model="formWebinarRecord.live_at" mode="dateTime" is24hr>
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                        class="p-2 border rounded focus:outline-none focus:ring-indigo-500  focus:border-indigo-500 w-full text-sm text-gray-700 border-gray-300"
                        :value="inputValue"
                        v-on="inputEvents"
                      />
                    </template>
                  </v-date-picker>
                </div>
              </div>
            </div>
          </div>
          <div v-if="webinarType" class="text-right px-6 py-3">
            <button @click.prevent="submitWebinar"
              class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-1.5 rounded outline-none focus:outline-none"
              :class="webinarId > 0 ? 'bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600' : 'bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600'"
              type="button" style="transition: all .15s ease">
              {{ webinarId > 0 ? 'Ubah' : 'Next' }}
              <i v-if="loadingWebinar" class="fas fa-spinner animate-spin ml-2 self-center"></i>
              <div v-else class="flex items-center self-center">
                <i class="ml-2 fas fa-angle-right self-center"></i>
                <i class="fas fa-angle-right self-center"></i>
              </div>
            </button>
          </div>
          <div v-else class="text-right px-6 py-3">
            <button @click.prevent="submitWebinarRecord"
              class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-1.5 rounded outline-none focus:outline-none"
              :class="webinarRecordId > 0 ? 'bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600' : 'bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600'"
              type="button" style="transition: all .15s ease">
              {{ webinarRecordId > 0 ? 'Ubah' : 'Tambah' }}
              <!-- <i class="ml-2 fas fa-chevron-right self-center"></i> -->
              <i 
                class="ml-2 self-center"
                :class=" webinarRecordId > 0 ? 'fas fa-edit' : 'fas fa-plus ' "
              ></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    </transition>

    <!-- modal question -->
    <transition name="pop">
    <div v-if="displayModalWebinarQuizAnswer"
      class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-3/4 md:w-1/3 m-auto">
        <div class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-85">
          <div
            class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
            <h3 class="text-xl font-semibold text-white">
              {{ questionId > 0 ? 'Ubah Pertanyaan' : 'Tambah Pertanyaan' }}
            </h3>
            <button
              class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
              v-on:click="closeWebinarQuizAnswer">
              <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
            </button>
          </div>
          <div class="relative px-6 py-3 overflow-y-auto overflow-x-hidden">
            <div v-if="questionId == 0 " class="w-full pb-3 text-center">
              <div class="bg-gray-200 text-sm text-gray-500 leading-none border-2 border-gray-200 rounded-full inline-flex">
                <button class="inline-flex items-center transition-colors duration-300 ease-in focus:outline-none px-4 py-2" :class="!importFile ? 'bg-white text-green-600 rounded-full font-bold' : 'hover:text-gray-600 focus:text-gray-600 rounded-l-full'" @click="importFile = false" id="grid">
                  <i class="fas fa-keyboard mr-2"></i>
                  <span>Tambah Manual</span>
                </button>
                <button class="inline-flex items-center transition-colors duration-300 ease-in focus:outline-none px-4 py-2" :class="importFile ? 'bg-white text-indigo-600 rounded-full font-bold' : 'hover:text-gray-600 focus:text-gray-600 rounded-r-full'" @click="importFile = true" id="list">
                  <i class="fas fa-file-upload mr-2"></i>
                  <span>Import File</span>
                </button>
              </div>
            </div>
            <div v-if="importFile">
              <div class="w-full pb-3">
                <label for="" class="block text-sm font-medium text-gray-700">
                  Pilih File
                </label>
                <div class="mt-1">
                  <label 
                    class="w-full flex flex-col items-center px-4 py-6 rounded-md shadow-xm tracking-wide cursor-pointer"
                    :class="selectedFile ? 'bg-indigo-600 text-white' : 'bg-white text-indigo-600 border border-gray-300 hover:text-indigo-800'"
                  >
                    <svg v-if="!selectedFile" class="w-9 h-9" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                    </svg>
                    <svg v-else class="w-9 h-9" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"></path></svg>
                    <span class="mt-1 text-base leading-normal font-semibold">{{ selectedFile ? selectedFile.name : 'Pilih file CSV' }}</span>
                    <span v-if="selectedFile" class="mt-2 text-xs font-medium underline">Ubah File</span>
                    <input type='file' class="hidden" @change="onFileChange"/>
                  </label>
                </div>
                <p class="text-xs text-gray-500 mt-2">Sampel File: untuk sampel bisa <a href="/files/format-quiz.csv" download class="text-blue-600">unduh disini</a>. Wajib menggunakan <span class="font-semibold">field delimiter ;</span> dan <span class="font-semibold">jangan hapus kolom pertama</span> pada sampel</p>
              </div>
            </div>
            <div v-else>
              <div class="w-full pb-3">
                <label for="question" class="block text-sm font-medium text-gray-700">
                  Pertanyaan
                </label>
                <div class="mt-1">
                  <textarea v-model="payload.question" id="question" name="question" rows="3"
                    class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                    placeholder="Masukkan Pertanyaan"></textarea>
                </div>
              </div>

              <div class="w-full pb-3">
                <label for="country" class="block text-sm font-medium text-gray-700">Pilih Format Jawaban</label>
                <select id="format" name="format" autocomplete="format" v-model="format"
                  class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                  <option value="trueFalse">Benar atau Salah</option>
                  <option value="multiple">Pilihan Ganda</option>
                </select>
              </div>

              <div v-if="format === 'trueFalse'" class="w-full pb-3">
                <label for="trueFalseAnswer" class="block text-sm font-medium text-gray-700">Pilih Jawaban yang
                  benar</label>
                <div class="flex items-center mt-2">
                  <input id="true" name="trueFalseAnswer" v-model="selectedAnswer" value="0" type="radio"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="true" class="ml-3 block text-sm font-medium text-gray-700">
                    Benar
                  </label>
                </div>
                <div class="flex items-center mt-2">
                  <input id="trueFalseAnswer" name="trueFalseAnswer" v-model="selectedAnswer" value="1" type="radio"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <label for="false" class="ml-3 block text-sm font-medium text-gray-700">
                    Salah
                  </label>
                </div>

              </div>
              <div v-else class="w-full pb-3">
                <label for="multiple" class="block text-sm font-medium text-gray-700">Masukkan Jawaban dan Pilih Jawaban
                  yang benar</label>
                <div class="flex items-center mt-2">
                  <input id="true" name="multiple" v-model="selectedAnswer" type="radio" value="0"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <input type="text" placeholder="pilihan jawaban 1"
                    class="mt-1 ml-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    v-model="answer[0]" />
                </div>
                <div class="flex items-center mt-2">
                  <input id="true" name="multiple" v-model="selectedAnswer" type="radio" value="1"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <input type="text" placeholder="pilihan jawaban 2"
                    class="mt-1 ml-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    v-model="answer[1]" />
                </div>
                <div class="flex items-center mt-2">
                  <input id="true" name="multiple" v-model="selectedAnswer" type="radio" value="2"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <input type="text" placeholder="pilihan jawaban 3"
                    class="mt-1 ml-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    v-model="answer[2]" />
                </div>
                <div class="flex items-center mt-2">
                  <input id="true" name="multiple" v-model="selectedAnswer" type="radio" value="3"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300">
                  <input type="text" placeholder="pilihan jawaban 4"
                    class="mt-1 ml-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    v-model="answer[3]" />
                </div>
              </div>

              <div class="w-full">
                <label for="point" class="block text-sm font-medium text-gray-700">
                  Point
                </label>
                <div class="mt-1">
                  <input name="point" id="point" type="number" v-model="payload.point"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                </div>
              </div>
            </div>
          </div>
          <div class="text-right px-6 py-3">
            <button @click.prevent="submitQuestion"
              class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-1.5 rounded outline-none focus:outline-none"
              :class="questionId > 0 ? 'bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600' : 'bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600'"
              type="button" style="transition: all .15s ease">
              {{ importFile ? 'Import' : questionId > 0 ? 'Ubah' : 'Tambah' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    </transition>
    
    <!-- modal quiz -->
    <transition name="pop">
    <div v-if="displayModalWebinarQuiz"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-3/4 md:w-1/3 m-auto">
        <div class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-85">
          <div
            class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
            <h3 class="text-xl font-semibold text-white">
              {{ webinarQuizId > 0 ? 'Ubah Pre/Post-test' : 'Tambah Pre/Post-test' }}
            </h3>
            <button
              class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
              v-on:click="closeWebinarQuiz">
              <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
            </button>
          </div>
          <div class="px-6 py-3 overflow-y-auto overflow-x-hidden">
            <div class="w-full pb-3">
              <label for="name" class="block text-sm font-medium text-gray-700">
                Nama
              </label>
              <div class="mt-1">
                <input v-model="formWebinarQuiz.name" id="name" slug="name" type="text"
                  placeholder="Nama Pre/Post-test"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
              </div>
            </div>

            <div class="w-full pb-3">
              <label for="slug" class="block text-sm font-medium text-gray-700">
                Slug
              </label>
              <div class="mt-1">
                <input v-model="formWebinarQuiz.slug" id="slug" slug="slug" type="text"
                  placeholder="nama-slug-pre-post-test"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                />
                <p class="text-xs text-gray-500 mt-1">
                  Contoh slug:
                </p>
                <p class="text-xs text-gray-500 mt-1">
                  https://platform.sekolahdesain.id/webinar-quiz/<span class="font-semibold text-red-500">nama-slug-pre-post-test</span>
                </p>
              </div>
            </div>

            <div class="w-full pb-3">
              <label class="block text-sm font-medium text-gray-700">Tipe Quiz<span class="text-red-600 font-bold">*</span></label>
              <div class="mt-1">
                <select 
                  v-model="formWebinarQuiz.quizType"
                  class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option v-if="isExistWebinarQuiz != 0" :value="0">Pre-Test</option>
                  <option v-if="isExistWebinarQuiz != 1" :value="1">Post-Test</option>
                </select>
              </div>
            </div>
            
            <div class="w-full pb-3">
              <div class="mt-1">
                <div class="col-span-6 sm:col-span-3 ">
                    <div class="grid grid-cols-2 gap-2">
                        <div class="w-full">
                            <p class="block text-sm font-medium text-gray-700">Dimulai</p>
                              <!-- <Calendar id="startedAt" v-model="formWebinarQuiz.startedAt" class="w-full" :showTime="true" dateFormat="yy-mm-dd" :showSeconds="true" /> -->
                              <v-date-picker v-model="formWebinarQuiz.startedAt" mode="dateTime" is24hr :popover="{ placement: 'left' }">
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input
                                    class="p-2 border rounded focus:outline-none focus:ring-indigo-500  focus:border-indigo-500 w-full text-sm text-gray-700 border-gray-300"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                  />
                                </template>
                              </v-date-picker>
                        </div>
                          <div class="w-full">
                            <p class="block text-sm font-medium text-gray-700">Berakhir</p>
                              <!-- <Calendar id="endedAt" v-model="formWebinarQuiz.endedAt" class="w-full" :showTime="true" dateFormat="yy-mm-dd" :showSeconds="true" /> -->
                              <v-date-picker v-model="formWebinarQuiz.endedAt" mode="dateTime" is24hr :popover="{ placement: 'right' }">
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input
                                    class="p-2 border rounded focus:outline-none focus:ring-indigo-500  focus:border-indigo-500 w-full text-sm text-gray-700 border-gray-300"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                  />
                                </template>
                              </v-date-picker>
                        </div>
                    </div>
                  </div>
              </div>
            </div>

            <div class="w-full pb-3">
              <label for="slug" class="block text-sm font-medium text-gray-700">
                Soal yang ditampilkan
              </label>
              <div class="mt-1">
                <input v-model="formWebinarQuiz.display" id="display" slug="display" type="text"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                  />
              </div>
            </div>

            <div class="w-full">
              <div class="flex items-start">
                  <div class="flex items-center h-5">
                      <input v-model="formWebinarQuiz.isRandomized" id="isRandomized" name="isRandomized" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                  </div>
                  <div class="ml-3 text-sm">
                      <label for="isRandomized" class="font-medium text-gray-700 cursor-pointer">Soal diacak?</label>
                      <p class="text-gray-500">Centang untuk menandakan soal diacak atau random</p>
                  </div>
                </div>
            </div>
          
          </div>
          <div class="text-right px-6 py-3">
            <button @click.prevent="submitWebinarQuiz"
              class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-2 rounded outline-none focus:outline-none"
              type="button" style="transition: all .15s ease"
              :class="webinarQuizId > 0 ? 'border-yellow-500 bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-600' : 'border-red-500 bg-red-500 hover:bg-red-600 active:bg-red-600' "
            >
              {{ webinarQuizId > 0 ? 'Ubah' : 'Tambah' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    </transition>

    <Delete
      :display="displayDeleteWebinar"
      title="Delete Webinar?"
      note=""
      :close="closeDeleteWebinar"
      :deleteBtn="webinarDelete"
    />

    <Delete
      :display="displayDeleteWebinarQuiz"
      title="Delete Webinar Quiz?"
      note=""
      :close="closeDeleteWebinarQuiz"
      :deleteBtn="webinarQuizDelete"
    />

    <Delete
      :display="displayDeleteWebinarQuizAnswer"
      title="Delete Pertanyaan?"
      note=""
      :close="closeDeleteWebinarQuizAnswer"
      :deleteBtn="questionDelete"
    />

    <Delete
      :display="displayDeleteWebinarRecord"
      title="Delete Rekaman Webinar?"
      note=""
      :close="closeDeleteWebinarRecord"
      :deleteBtn="webinarRecordDelete"
    />
    <Toast />
  </div>
</template>
<script>
import moment from 'moment'
import Back from '@/layout/Component/Back'
import Step from '@/layout/Component/Step'
import Delete from '@/layout/Component/Delete'
import { Classroom } from '@/api/classroom'
import {
    mapActions,
    mapGetters
} from 'vuex'
import {
  FilterMatchMode
} from 'primevue/api'

export default {

    components: {
        Back,
        Step,
        Delete,
    },

    data() {
        return {
            formWebinar: {
                name: '',
                link: '',
                pin: '',
                started_at: '',
                expired_at: '',
                classroom_level_id: 0,
                is_active: false,
                can_request_plus: false,
                room_id: 0,
                request_plus_started_at: '',
                request_plus_expired_at: '',
                thumbnail: '',
            },
            formWebinarRecord: {
              name: '',
              link: '',
              description: '',
              classroom_id: 0,
              live_at: '',
            },
            formWebinarQuiz: {
                name: '',
                slug: '',
                description: '',
                shortDescription: '',
                ordering: 1,
                display: 0,
                quizType: 0,
                startedAt: '',
                endedAt: '',
                webinarId: 0,
                isActive: true,
                isRandomized: false,
            },
            answer: [],
            selectedAnswer: 0,
            payload: {
              question: '',
              choices: '',
              answer: 0,
              point: 0,
              ordering: 0,
              webinarQuizId: 0
            },
            format: 'trueFalse',
            displayModal: false,
            filters: {
              global: {
                value: null,
                matchMode: FilterMatchMode.CONTAINS
              },
            },
            questionId: 0,
            classroomId: 0,
            webinarId: 0,
            webinarRecordId: 0,
            webinarQuizId: 0,
            webinarQuizAnswerId: 0,
            webinars: null,
            classroomLevel: {},
            selectedWebinar: null,
            selectedWebinarQuiz: null,
            selectedWebinarQuizAnswer: null,
            displayModalWebinar: false,
            displayModalWebinarQuiz: false,
            displayModalWebinarQuizAnswer: false,
            whatsNext: '',
            step: 3,
            displayDeleteWebinar: false,
            displayDeleteWebinarQuiz: false,
            displayDeleteWebinarQuizAnswer: false,
            displayDeleteWebinarRecord: false,
            webinarType: true,
            selectedWebinarRecord: null,
            useRoom: false,
            selectedRoom: null,
            importFile: false,
            selectedFile: null,
            disabledWebinarQuiz: false,
            isExistWebinarQuiz: 2,
            isWebinarPlus: false,
            loadingWebinar: false,
            useThumbnail: false,
        }
    },
    async created() {
        this.classroomId = this.$route.params.classroomId
        this.webinarId = this.$route.params.id
        if (this.classroomId && (this.classroom?.id != this.classroomId)) {
            this.getClassroomDetail()
        } else {
             this.next()
        }
        if ((this.quizList?.length == 0) || (this.classroomId != this.savedIdClassroomQuiz)) {
            const query = {
              classroomId: this.classroomId,
              isExpired: '',
            }
            await this.fetchAllWebinars(query)
        }
        if ((this.webinarRecordList?.length == 0)|| (this.savedIdClassroomWebinarRecord != this.classroomId)) {
            await this.fetchAllWebinarRecords(this.classroomId)
        }
        this.getAllList()
        this.fetchAllRooms()
    },
    computed: {
        ...mapGetters(["classroom", "webinar","isLoadingWebinar", "isSuccessWebinar", "messageWebinar", "webinarList", "webinarQuizzes", "loadingWebinarQuiz", "isSuccessWebinarQuiz", "messageWebinarQuiz", "savedIdWebinar", "isSuccessWebinarQuiz", "messageWebinarQuiz",  "webinarQuiz", "webinarQuizItems", "savedIdWebinarQuiz", "webinarRecordList", "isSuccessWebinarRecord", "isLoadingWebinarRecord", "messageWebinarRecord", "savedIdClassroomWebinarRecord", "webinarRecord", "createdWebinar", "createdWebinarQuiz", "createdWebinarRecord", "rooms"]),
    },
    methods: {
        ...mapActions(["fetchDetailClassroom", "fetchAllWebinars", "fetchDetailWebinar", "updateWebinar", "addWebinar", "deleteWebinar", "fetchAllWebinarQuizFilter", "deleteWebinarQuiz", "fetchDetailWebinarQuiz", "updateWebinarQuiz", "addWebinarQuiz", "fetchAllWebinarQuizItemsFilter", "fetchDetailWebinarQuizItem", "deleteWebinarQuizItem", "addWebinarQuizItem", "updateWebinarQuizItem", "fetchAllWebinarRecords", "fetchDetailWebinarRecord", "updateWebinarRecord", "addWebinarRecord", "deleteWebinarRecord", "fetchAllRooms", "updateWebinarThumbnail"]),
        checkPrePostTestExist() {
          const isExistPreTest = this.webinarQuizzes.some(el => el.quiz_type == 0)
          const isExistPostTest = this.webinarQuizzes.some(el => el.quiz_type == 1)
          if(isExistPreTest && isExistPostTest) {
            this.disabledWebinarQuiz = true
            this.isExistWebinarQuiz = -1
          } else if (isExistPreTest) {
            this.disabledWebinarQuiz = false
            this.isExistWebinarQuiz = 0
          } else if (isExistPostTest) {
            this.disabledWebinarQuiz = false
            this.isExistWebinarQuiz = 1
          } else {
            this.disabledWebinarQuiz = false
            this.isExistWebinarQuiz = 2
          }
        },
        getAllList() {
          this.webinarList.forEach(el => {
            el.type = 'webinar'
          })
          this.webinarRecordList.forEach(el => {
            el.type = 'record'
          })
          this.webinars = this.webinarList.concat(this.webinarRecordList)
        },
        async getClassroomDetail() {
            await this.fetchDetailClassroom(this.classroomId)
            this.next()
        },
        toggleWebinarType() {
          this.webinarType = !this.webinarType
        },
        next() {
            if(this.classroom?.must_quizzes_tab) {
                this.whatsNext = 'quiz'
               
            } else {
                this.whatsNext = ''
            }
        },
        nextStep(){
          let confirmation
          if(!this.webinarList?.length) {
              confirmation = confirm('Tidak ada webinar dalam kelas ini, apakah yakin ingin ke langkah selanjutnya?')
          } else {
              confirmation = confirm('Apakah yakin ingin ke langkah selanjutnya?')
          }
          if(confirmation) {
            if(this.whatsNext != '') {
                  this.$router.push('/classroom/' + this.classroom.id + '/step/' + this.whatsNext)
            } else {
                  this.$router.push('/classroom/' + this.classroom.id + '/detail')
            }
          }
        },
        
        async getWebinar() {
            await this.fetchDetailWebinar(this.webinarId)
            this.isLoading = false
            this.formWebinar.name = this.webinar.name
            this.formWebinar.link = this.webinar.link
            this.formWebinar.pin = this.webinar.pin
            this.formWebinar.classroom_level_id = this.webinar.classroom_level_id
            this.formWebinar.is_active = this.webinar.is_active
            this.formWebinar.started_at = moment(this.webinar.started_at).format(
                'YYYY-MM-DD HH:mm:ss'
            )
            this.formWebinar.expired_at = moment(this.webinar.expired_at).format(
                'YYYY-MM-DD HH:mm:ss'
            )
            this.formWebinar.can_request_plus = this.webinar.can_request_plus
            this.formWebinar.room_id = this.webinar.room_id
            this.formWebinar.thumbnail = this.webinar.thumbnail
            const thumbnail = document.getElementById('webinarThumbnail')
            if(thumbnail) {
              thumbnail.value = null
            }
            if(this.webinar.request_plus_started_at == '0001-01-01 00:00:00') {
              this.formWebinar.request_plus_started_at = ''
            } else {
              this.formWebinar.request_plus_started_at = moment(this.webinar.request_plus_started_at).format('YYYY-MM-DD HH:mm:ss')
            }
            if(this.webinar.request_plus_expired_at == '0001-01-01 00:00:00') {
              this.formWebinar.request_plus_expired_at = ''
            } else {
              this.formWebinar.request_plus_expired_at = moment(this.webinar.request_plus_expired_at).format('YYYY-MM-DD HH:mm:ss')
            }
            if(this.formWebinar.room_id > 0) {
              this.useRoom = true
              const room = this.rooms.filter(el => el.id == this.webinar.room_id)
              if(room.length > 0) {
                this.selectedRoom = room[0] 
              }
            } else {
              this.selectedRoom = null
            }
            this.isWebinarPlus = this.webinar.is_plus
        },
        uploadThumbnail(event) {
          this.useThumbnail = true
          this.formWebinar.thumbnail = event.target.files[0]
        },
        addNewWebinar() {
          this.displayModalWebinar = true
          this.webinarId = 0
          this.formWebinar.name = ''
          this.formWebinar.link = ''
          this.formWebinar.pin = ''
          this.formWebinar.started_at = ''
          this.formWebinar.expired_at = ''
          this.formWebinar.can_request_plus = false
          this.formWebinar.room_id = 0
          this.formWebinar.request_plus_started_at = ''
          this.formWebinar.request_plus_expired_at = ''
          this.useRoom = false
          this.is_active = false
          this.formWebinarRecord.name = ''
          this.formWebinarRecord.link = ''
          this.formWebinarRecord.description = ''
          this.formWebinarRecord.classroom_id = 0
          this.formWebinarRecord.live_at = ''
          this.webinarRecordId = 0
          this.formWebinar.thumbnail = ''
          const thumbnail = document.getElementById('webinarThumbnail')
          if(thumbnail) {
            thumbnail.value = null
          }
        },
        async editWebinar(data) {
          if(data.type == 'webinar') {
            this.selectedWebinar = data
            this.webinarId = data.id
            this.webinarRecordId = 0
            await this.getWebinar()
            this.displayModalWebinar = true
            this.webinarType = true
          } else if (data.type == 'record') {
            this.selectedWebinar = data
            this.webinarId = 0
            this.webinarRecordId = data.id
            await this.getWebinarRecord()
            this.displayModalWebinar = true 
            this.webinarType = false
          }
        },
        closeWebinar() {
          this.displayModalWebinar = false
          this.webinarId = 0
          this.webinarRecordId = 0
          this.isWebinarPlus = false
        },
        addWebinarQuizModal() {
          this.displayModalWebinarQuiz = true
          this.webinarQuizId = 0
          this.formWebinarQuiz.name = ''
          this.formWebinarQuiz.slug = ''
          this.formWebinarQuiz.description = ''
          this.formWebinarQuiz.shortDescription = ''
          this.formWebinarQuiz.ordering = 1
          this.formWebinarQuiz.display = 0
          this.formWebinarQuiz.quizType = 0
          this.formWebinarQuiz.startedAt = ''
          this.formWebinarQuiz.endedAt = ''
          this.formWebinarQuiz.webinarId = 0
          this.formWebinarQuiz.isRandomized = false
        },
        async editWebinarQuiz(data) {
          this.selectedWebinarQuiz = data
          this.webinarQuizId = data.id
          await this.getWebinarQuiz()
          this.displayModalWebinarQuiz = true
        },
        closeWebinarQuiz() {
          this.displayModalWebinarQuiz = false
        },
        addWebinarQuizAnswerModal() {
          this.displayModalWebinarQuizAnswer = true
          this.webinarQuizAnswerId = 0
          this.payload.question = ''
          this.payload.choices = ''
          this.payload.answer = 0
          this.payload.point = 0
          this.payload.ordering = 0
          this.payload.webinarQuizId = 0
        },
        async editWebinarQuizItem(id) {
          this.webinarQuizAnswerId = id
          this.questionId = id
          this.payload = this.webinarQuizItems.filter(e => e.id === id)[0]
          this.answer = JSON.parse(this.payload.choices)
          if (this.answer?.length <= 2) {
            this.format = 'trueFalse'
          } else {
            this.format = 'multiple'
          }
          this.selectedAnswer = this.payload.answer
          this.displayModalWebinarQuizAnswer = true
        },
        closeWebinarQuizAnswer() {
          this.displayModalWebinarQuizAnswer = false
          this.webinarQuizAnswerId = 0
          this.questionId = 0
          this.selectedAnswer = 0
          this.payload = {
            question: '',
            choices: '',
            answer: 0,
            point: 0,
            ordering: 0,
            webinarQuizId: 0
          }
          this.answer = []
          this.importFile = false
          this.selectedFile = null
          this.fetchAllWebinarQuizItemsFilter(this.webinarQuizId)
        },
        async onRowSelectWebinar(event) {
          this.webinarId = 0
          this.webinarRecordId = 0
          this.selectedWebinar  = event.data
          if(event.data.type == 'webinar') {
            this.webinarId = event.data.id
            await this.fetchAllWebinarQuizFilter(event.data.id)
            this.checkPrePostTestExist()
            this.selectedWebinarQuiz = null
          } else {
            this.webinarRecordId = event.data.id
            this.selectedWebinarRecord = event.data
          }
        },
        async onRowSelectWebinarQuiz(event) {
          this.selectedWebinarQuiz  = event.data
          this.webinarQuizId = event.data.id
          await this.fetchAllWebinarQuizItemsFilter(this.webinarQuizId)
        },
        showDeleteWebinar(id) {
          this.webinarId = id
          this.displayDeleteWebinar = true
        },
        closeDeleteWebinar() {
          this.webinarId = 0
          this.displayDeleteWebinar = false
        },
        async webinarDelete() {
          await this.deleteWebinar(this.webinarId)
          if (this.isSuccessWebinar) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: this.messageWebinar,
              life: 1000
            })
            this.closeDeleteWebinar()
            const query = {
              classroomId: this.classroomId,
              isExpired: '',
            }
            this.webinarId = 0
            this.selectedWebinar = null
            this.selectedWebinarQuiz = null
            await this.fetchAllWebinars(query)
            this.getAllList()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: this.messageWebinar
            })
          }
        },
        async submitWebinar() {
            this.formWebinar.started_at = moment(this.formWebinar.started_at).format(
                'YYYY-MM-DD HH:mm:00'
            )
            this.formWebinar.expired_at = moment(this.formWebinar.expired_at).format(
                'YYYY-MM-DD HH:mm:00'
            )
            if (this.webinarId) {
                if (
                    (this.useRoom || this.formWebinar.link) &&
                    (!this.useRoom || this.selectedRoom) &&
                    this.formWebinar.classroom_level_id &&
                    this.formWebinar.name &&
                    this.formWebinar.started_at &&
                    this.formWebinar.expired_at &&
                    (!this.formWebinar.can_request_plus || (this.formWebinar.request_plus_started_at && this.formWebinar.request_plus_started_at != '0001-01-01 00:00:00') ) &&
                    (!this.formWebinar.can_request_plus || (this.formWebinar.request_plus_expired_at && this.formWebinar.request_plus_expired_at != '0001-01-01 00:00:00'))
                ) {
                    if(this.useRoom) {
                      this.formWebinar.link = ''
                      this.formWebinar.room_id = this.selectedRoom.id
                    } else {
                      this.formWebinar.room_id = 0
                    }
                    if(new Date(this.formWebinar.started_at) >= new Date(this.formWebinar.expired_at)) {
                      this.$toast.add({
                        severity: 'error',
                        summary: 'Failed Webinar Date',
                        detail: 'Tanggal berakhir webinar harus lebih besar dari tangal dimulai webinar',
                        life: 5000
                      })
                      return
                    }
                    if(this.formWebinar.can_request_plus) {
                      if(new Date(this.formWebinar.request_plus_started_at) >= new Date(this.formWebinar.request_plus_expired_at)) {
                        this.$toast.add({
                          severity: 'error',
                          summary: 'Failed Webinar Plus',
                          detail: 'Tanggal pengajuan berakhir harus lebih besar dari tangal pengajuan dimulai',
                          life: 5000
                        })
                        return
                      } else {
                        this.formWebinar.request_plus_started_at = moment(this.formWebinar.request_plus_started_at).format('YYYY-MM-DD HH:mm:00')
                        this.formWebinar.request_plus_expired_at = moment(this.formWebinar.request_plus_expired_at).format('YYYY-MM-DD HH:mm:00')
                      }
                    }
                    const webinar = {
                        id: this.webinarId,
                        payload: this.formWebinar
                    }
                    this.loadingWebinar = true
                    if(this.useThumbnail) {
                      await this.updateWebinarThumbnail(webinar)
                    } else {
                      await this.updateWebinar(webinar)
                    }
                    this.useThumbnail = false
                    if (this.isSuccessWebinar) {
                      const query = {
                        classroomId: this.classroomId,
                          isExpired: '',
                        }
                        await this.fetchAllWebinars(query)
                        this.webinarId = 0
                        this.loadingWebinar = false
                        this.closeWebinar()
                        this.getAllList()
                        const getWebinar = this.webinars.filter(el =>
                          el.id == this.createdWebinar.id && el.type == 'webinar'
                        )
                        if (getWebinar.length > 0) {
                          this.selectedWebinar = getWebinar[0]
                        }
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: this.messageWebinar,
                            life: 1000
                        })
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Failed',
                            detail: this.messageWebinar
                        })
                    }
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Nama, link, tanggal webinar dan pengajuan webinar++ tidak boleh kosong',
                        life: 3000
                    })
                }
            } else {
                this.formWebinar.classroom_level_id = this.classroom.levels[0].id
                if (
                    (this.useRoom || this.formWebinar.link) &&
                    (!this.useRoom || this.selectedRoom) &&
                    this.formWebinar.classroom_level_id &&
                    this.formWebinar.name &&
                    this.formWebinar.started_at &&
                    this.formWebinar.expired_at &&
                    (!this.formWebinar.can_request_plus || (this.formWebinar.request_plus_started_at && this.formWebinar.request_plus_started_at != '0001-01-01 00:00:00') ) &&
                    (!this.formWebinar.can_request_plus || (this.formWebinar.request_plus_expired_at && this.formWebinar.request_plus_expired_at != '0001-01-01 00:00:00'))
                ) {
                    if(this.useRoom) {
                      this.formWebinar.link = ''
                      this.formWebinar.room_id = this.selectedRoom.id
                    } else {
                      this.formWebinar.room_id = 0
                    }
                    if(new Date(this.formWebinar.started_at) >= new Date(this.formWebinar.expired_at)) {
                      this.$toast.add({
                        severity: 'error',
                        summary: 'Failed Webinar Date',
                        detail: 'Tanggal berakhir webinar harus lebih besar dari tangal dimulai webinar',
                        life: 5000
                      })
                      return
                    }
                    if(this.formWebinar.can_request_plus) {
                      if(new Date(this.formWebinar.request_plus_started_at) >= new Date(this.formWebinar.request_plus_expired_at)) {
                        this.$toast.add({
                          severity: 'error',
                          summary: 'Failed Webinar Plus',
                          detail: 'Tanggal pengajuan berakhir harus lebih besar dari tangal pengajuan dimulai',
                          life: 5000
                        })
                        return
                      } else {
                        this.formWebinar.request_plus_started_at = moment(this.formWebinar.request_plus_started_at).format('YYYY-MM-DD HH:mm:00')
                        this.formWebinar.request_plus_expired_at = moment(this.formWebinar.request_plus_expired_at).format('YYYY-MM-DD HH:mm:00')
                      }
                    }
                    this.loadingWebinar = true
                    await this.addWebinar(this.formWebinar)
                    this.useThumbnail = false
                    if (this.isSuccessWebinar) {
                        const query = {
                          classroomId: this.classroomId,
                          isExpired: '',
                        }
                        await this.fetchAllWebinars(query)
                        this.loadingWebinar = false
                        this.closeWebinar()
                        this.getAllList()
                        const getWebinar = this.webinars.filter(el =>
                          el.id == this.createdWebinar.id && el.type == 'webinar'
                        )
                        if (getWebinar.length > 0) {
                          this.selectedWebinar = getWebinar[0]
                        }
                        this.webinarId = this.createdWebinar.id
                        await this.fetchAllWebinarQuizFilter(this.webinarId)
                        this.checkPrePostTestExist()
                        this.addWebinarQuizModal()
                        this.selectedWebinarQuiz = null
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: this.messageWebinar,
                            life: 1000
                        })
                        // setTimeout(() => this.$router.go(-1), 1000)
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Failed',
                            detail: this.messageWebinar
                        })
                    }
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Nama, link, tanggal webinar dan pengajuan webinar++ tidak boleh kosong',
                        life: 3000
                    })

                }
            }
        },

        async getWebinarQuiz() {
            await this.fetchDetailWebinarQuiz(this.webinarQuizId)
            this.formWebinarQuiz.name = this.webinarQuiz.name
            this.formWebinarQuiz.slug = this.webinarQuiz.slug
            this.formWebinarQuiz.ordering = this.webinarQuiz.ordering
            this.formWebinarQuiz.display = this.webinarQuiz.display
            this.formWebinarQuiz.shortDescription = this.webinarQuiz.short_description
            this.formWebinarQuiz.description = this.webinarQuiz.description
            this.formWebinarQuiz.webinarId = this.webinarQuiz.webinar_id
            this.formWebinarQuiz.quizType = this.webinarQuiz.quiz_type
            this.formWebinarQuiz.startedAt = this.webinarQuiz.started_at
            this.formWebinarQuiz.endedAt = this.webinarQuiz.ended_at
            this.formWebinarQuiz.isActive = this.webinarQuiz.is_active
            this.formWebinarQuiz.isRandomized = this.webinarQuiz?.is_randomized ? true : false 
        },
        async submitWebinarQuiz() {
            this.formWebinarQuiz.ordering = parseInt(this.formWebinarQuiz.ordering)
            this.formWebinarQuiz.webinarId = parseInt(this.webinarId)
            this.formWebinarQuiz.quizType = parseInt(this.formWebinarQuiz.quizType)
            this.formWebinarQuiz.startedAt = moment(this.formWebinarQuiz.startedAt).format('YYYY-MM-DD HH:mm:00')
            this.formWebinarQuiz.endedAt = moment(this.formWebinarQuiz.endedAt).format('YYYY-MM-DD HH:mm:00')
            this.formWebinarQuiz.display = parseInt(this.formWebinarQuiz.display)
            if (
                this.formWebinarQuiz.name &&
                this.formWebinarQuiz.slug &&
                this.formWebinarQuiz.ordering &&
                this.formWebinarQuiz.startedAt &&
                this.formWebinarQuiz.endedAt &&
                this.formWebinarQuiz.display
            ) {
                if (this.webinarQuizId) {
                    const data = {
                        id: this.webinarQuizId,
                        payload: this.formWebinarQuiz
                    }
                    await this.updateWebinarQuiz(data)
                    if (this.isSuccessWebinarQuiz) {
                        await this.fetchAllWebinarQuizFilter(this.webinarId)
                        this.checkPrePostTestExist()
                        this.closeWebinarQuiz()
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: this.messageWebinarQuiz,
                            life: 1000
                        })
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Failed',
                            detail: this.messageWebinarQuiz
                        })
                    }
                } else {
                    await this.addWebinarQuiz(this.formWebinarQuiz)
                    if (this.isSuccessWebinarQuiz) {
                        await this.fetchAllWebinarQuizFilter(this.webinarId)
                        this.checkPrePostTestExist()
                        this.closeWebinarQuiz()
                        const getWebinarQuiz = this.webinarQuizzes.filter(el =>
                          el.id == this.createdWebinarQuiz.id
                        )
                        if (getWebinarQuiz.length > 0) {
                          this.selectedWebinarQuiz = getWebinarQuiz[0]
                        }
                        this.webinarQuizId = this.createdWebinarQuiz.id
                        await this.fetchAllWebinarQuizItemsFilter(this.webinarQuizId)

                        this.addWebinarQuizAnswerModal()

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: this.messageWebinarQuiz,
                            life: 1000
                        })
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Failed',
                            detail: this.messageWebinarQuiz
                        })
                    }
                }
            } else {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Semua form harus diisi',
                    life: 3000
                })
            }
        },
        showDeleteWebinarQuiz(data) {
          this.selectedWebinarQuiz = data
          this.webinarQuizId = data.id
          this.displayDeleteWebinarQuiz = true
        },
        closeDeleteWebinarQuiz() {
          this.displayDeleteWebinarQuiz = false
        },
        async webinarQuizDelete() {
          await this.deleteWebinarQuiz(this.webinarQuizId)
          if (this.isSuccessWebinarQuiz) {
            this.closeDeleteWebinarQuiz()
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: this.messageWebinarQuiz,
              life: 1000
            })
            this.webinarQuizId = 0
            this.selectedWebinarQuiz = null
            setTimeout(async () => {
              await this.fetchAllWebinarQuizFilter(this.webinarId)
              this.checkPrePostTestExist()
            }, 1000)
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: this.messageWebinarQuiz
            })
          }
        },
        listQuestion(choices) {
          const formattedArray = JSON.parse(choices)
          return formattedArray
        },
        async submitQuestion() {
          if(this.importFile) {
            if(this.selectedFile) {
              const payload = {
                id: this.selectedWebinarQuiz.id,
                file: this.selectedFile
              }
              await Classroom.webinarQuizItemImport(payload)
              .then(async res => {
                if(res.data.success) {
                  this.closeWebinarQuizAnswer()
                  await this.fetchAllWebinarQuizItemsFilter(this.webinarQuizId)
                  this.$toast.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Berhasil menambahkan pertanyaan.',
                    life: 3000
                  })
                } else {
                  this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Terjadi Kesalahan',
                    life: 3000
                  })
                }
              })
              .catch(err => {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: err.errors[0].message,
                  life: 3000
                })
              })
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'File tidak boleh kosong',
                life: 3000,
              })
            }
          } else {
            this.payload.webinarQuizId = parseInt(this.webinarQuizId)
            if (this.format === 'trueFalse') {
              const answer = ["Benar", "Salah"]
              this.payload.choices = JSON.stringify(answer)
              if(this.selectedAnswer > 1) {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'pilih jawaban pertanyaan tidak boleh kosong',
                  life: 3000
                })
                return
              }
            } else {
              if (this.answer?.length === 4) {
                this.payload.choices = JSON.stringify(this.answer)
                // console.log(this.payload.choices)
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'jawaban harus 4 pilihan',
                  life: 3000
                })
              }
            }
            this.payload.answer = parseInt(this.selectedAnswer)
            this.payload.point = parseInt(this.payload.point)
            if (this.payload.webinarQuizId && this.payload.question && this.payload.choices) {
              if (this.questionId > 0) {
                //edit
                const question = {
                  id: this.questionId,
                  payload: this.payload
                }
                await this.updateWebinarQuizItem(question)
                if (this.isSuccessWebinarQuiz) {
                  this.closeWebinarQuizAnswer()
                  await this.fetchAllWebinarQuizItemsFilter(this.webinarQuizId)
                  this.$toast.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: this.messageWebinarQuiz,
                    life: 1000
                  })
                } else {
                  this.$toast.add({
                    severity: 'error',
                    summary: 'Failed',
                    detail: this.messageWebinarQuiz
                  })
                }
              } else {
                //add
                if(this.webinarQuizItems.length > 0) {
                  const ordering = this.webinarQuizItems.length
                  this.payload.ordering = ordering + 1
                } else {
                  this.payload.ordering = 1
                }
                await this.addWebinarQuizItem(this.payload)
                if (this.isSuccessWebinarQuiz) {
                  this.closeWebinarQuizAnswer()
                  await this.fetchAllWebinarQuizItemsFilter(this.webinarQuizId)
                  this.$toast.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: this.messageWebinarQuiz,
                    life: 1000
                  })
                } else {
                  this.$toast.add({
                    severity: 'error',
                    summary: 'Failed',
                    detail: this.messageWebinarQuiz
                  })
                }
              }
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'semua form harus diisi',
                life: 3000
              })
            }
          }
        },
        closeModal() {
          this.displayModal = false
          this.questionId = 0
          this.selectedAnswer = 0
          this.payload = {
            question: '',
            choices: '',
            answer: 0,
            point: 0,
            ordering: 0,
            webinarQuizId: 0
          }
          this.answer = []
          this.fetchAllWebinarQuizItemsFilter(this.webinarQuizId)
        },
        webinarQuizItemAdds() {
          this.displayModal = true
          this.questionId = 0
        },
        editQuestions(id) {
          this.questionId = id
          const question = this.webinarQuizItems.filter(e => e.id === id)
          this.payload = {
            question: question[0].question,
            choices: question[0].choices,
            answer: question[0].answer,
            point: question[0].point,
            ordering: question[0].ordering,
            webinarQuizId: question[0].webinar_quiz_id
          }
          this.answer = JSON.parse(this.payload.choices)
          if (this.answer?.length <= 2) {
            this.format = 'trueFalse'
          } else {
            this.format = 'multiple'
          }
          this.selectedAnswer = this.payload.answer
          this.displayModalWebinarQuizAnswer = true
        },
        showDeleteWebinarQuizAnswer(id) {
          this.questionId = id
          this.displayDeleteWebinarQuizAnswer = true
        },
        closeDeleteWebinarQuizAnswer() {
          this.questionId = 0
          this.displayDeleteWebinarQuizAnswer = false
        },
        async questionDelete() {
          await this.deleteWebinarQuizItem(this.questionId)
          if (this.isSuccessWebinarQuiz) {
            this.closeDeleteWebinarQuizAnswer()
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: this.messageWebinarQuiz,
              life: 1000
            })
            const indexDeleted = this.webinarQuizItems.findIndex(el =>
            el.id == this.questionId)
            this.webinarQuizItems.splice(indexDeleted,1)
            const effectedQuestion = []
            this.webinarQuizItems.forEach(async (el, i) => {
              if(el.ordering == i + 1 ) {
                effectedQuestion.push(false)
              } else {
                effectedQuestion.push(true)       
              }
            });
            const check = effectedQuestion.some(el => el == true)
            if(check) {
              for (let i = 0; i < effectedQuestion.length ; i++) {
                if(effectedQuestion[i]) {
                  const payload = {
                    choices: this.webinarQuizItems[i]?.choices,
                    answer: this.webinarQuizItems[i]?.answer,
                    ordering: i + 1,
                    point: this.webinarQuizItems[i]?.point,
                    question: this.webinarQuizItems[i]?.question,
                    webinarQuizId: this.webinarQuizItems[i]?.webinar_quiz_id,
                  }
                  const data = {
                    id: this.webinarQuizItems[i]?.id,
                    payload: payload
                  }
                  this.webinarQuizItems[i].ordering = i + 1
                  await this.updateWebinarQuizItem(data)
                }
              }
              await this.fetchAllWebinarQuizItemsFilter(this.webinarQuizId)
    
              this.$toast.add({
                severity: 'success',
                summary: 'success',
                detail: 'sukses dipindah',
                life: 1000
              })
            }
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: this.messageWebinarQuiz
            })
          }
        },
        async getWebinarRecord() {
          await this.fetchDetailWebinarRecord(this.webinarRecordId)
          this.formWebinarRecord.name = this.webinarRecord.name
          this.formWebinarRecord.link = this.webinarRecord.link
          this.formWebinarRecord.description = this.webinarRecord.description
          this.formWebinarRecord.classroom_id = this.webinarRecord.classroom_id
          this.formWebinarRecord.live_at = this.webinarRecord.live_at
        },
        async submitWebinarRecord() {
          this.formWebinarRecord.classroom_id = Number(this.classroomId)
          this.formWebinarRecord.description = this.formWebinarRecord.name
          this.formWebinarRecord.live_at = moment(this.formWebinarRecord.live_at).format('YYYY-MM-DD HH:mm:00')
          if (
              this.formWebinarRecord.classroom_id &&
              this.formWebinarRecord.link &&
              this.formWebinarRecord.name &&
              this.formWebinarRecord.live_at
          ) {
            if (this.webinarRecordId) {
              // update
              const webinarRecord = {
                id: this.webinarRecordId,
                payload: this.formWebinarRecord
              }
              await this.updateWebinarRecord(webinarRecord)
              if (this.isSuccessWebinarRecord) {
                this.closeWebinar()
                await this.fetchAllWebinarRecords(this.classroomId)
                this.getAllList()
                this.$toast.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: this.messageWebinarRecord,
                  life: 1000
                })
                // setTimeout(() => this.$router.go(-1), 1000)
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Failed',
                  detail: this.messageWebinarRecord
                })
              }

            } else {
              // add
              await this.addWebinarRecord(this.formWebinarRecord)
              if (this.isSuccessWebinarRecord) {
                await this.fetchAllWebinarRecords(this.classroomId)
                this.closeWebinar()
                this.getAllList()
                const getWebinarRecord = this.webinars.filter(el => 
                  el.id == this.createdWebinarRecord.id && el.type == 'record'
                )
                if(getWebinarRecord.length > 0) {
                  this.selectedWebinarRecord = getWebinarRecord[0]
                  this.selectedWebinar = getWebinarRecord[0]
                }
                this.webinarRecordId = this.createdWebinarRecord.id
                this.$toast.add({
                  severity: 'success',
                  summary: 'Success',
                  detail:  this.messageWebinarRecord,
                  life: 1000
                })
                // setTimeout(() => this.$router.go(-1), 1000)
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Failed',
                  detail: this.messageWebinarRecord
                })
              }
            }
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Semua Form Harus diisi',
              life: 3000
            })
          }
        },
        showDeleteWebinarRecord(id) {
          this.webinarRecordId = id
          this.displayDeleteWebinarRecord = true
        },
        closeDeleteWebinarRecord() {
          this.webinarRecordId = 0
          this.displayDeleteWebinarRecord = false
        },
        async webinarRecordDelete() {
          await this.deleteWebinarRecord(this.webinarRecordId)
          if (this.isSuccessWebinarRecord) {
            await this.fetchAllWebinarRecords(this.classroomId)
            this.closeDeleteWebinarRecord()
            this.getAllList()
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: this.messageWebinarRecord,
              life: 1000
            })
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: this.messageWebinarRecord
            })
          }
        },
        async onRowReorder(event) {
          const effectedQuestion = []
          this.webinarQuizItems.forEach(async (el, i) => {
            if(el.id == event.value[i].id ) {
                effectedQuestion.push(false)
            } else {
                effectedQuestion.push(true)       
            }
          });
          const check = effectedQuestion.some(el => el == true)
          if(check) {
            for (let i = 0; i < effectedQuestion.length ; i++) {
              if(effectedQuestion[i]) {
                const payload = {
                  choices: event.value[i]?.choices,
                  answer: event.value[i]?.answer,
                  ordering: i + 1,
                  point: event.value[i]?.point,
                  question: event.value[i]?.question,
                  webinarQuizId: event.value[i]?.webinar_quiz_id,
                }
                const data = {
                  id: event.value[i]?.id,
                  payload: payload
                }
                this.webinarQuizItems[i].ordering = i + 1
                await this.updateWebinarQuizItem(data)
              }
            }
            await this.fetchAllWebinarQuizItemsFilter(this.webinarQuizId)
  
            this.$toast.add({
              severity: 'success',
              summary: 'success',
              detail: 'sukses dipindah',
              life: 1000
            })
          }
        },
        onFileChange(event) {
          if (event.target.files[0].type == 'text/csv' || event.target.files[0].name.includes('.csv')) {
            this.selectedFile = event.target.files[0];
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: 'File harus bertipe CSV',
              life: 3000
            })
          }
        },
        dateFormat(date) {
          return moment(date).locale('id').format('DD MMMM YYYY HH:mm:ss')
        },
    }
}
</script>

<style scoped>
.toggle-checkbox:checked {
  @apply: right-0 border-green-400;
  right: 0;
  border-color: #10B981;
}
.toggle-checkbox:checked + .toggle-label {
  @apply: bg-green-400;
  background-color: #10B981;
}
::v-deep(.vc-select select) {
  background-image: unset;
}
</style>